<template>
  <div id="video">
    <div v-if="!browserSupported && videoSourceLoaded" id="not-suporrted">
      <p>このブラウザーは配信を見ることができません</p>
    </div>
    <div v-if="!videoSourceLoaded" id="no-source">
      <p>
        配信ソースが設定されていません <br />
        配信ソースが設定されて配信が表示されない場合は <br />
        ページをリロードしてみてください
      </p>
    </div>
    <video
      id="amazonIvsVideojs"
      ref="amazonIvsVideojs"
      :class="videoClass"
      autoplay
      playsinline
      ontrolsList="nodownload"
      oncontextmenu="return false;"
      :poster="thumbnailURL"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'Video',
  props: {
    liveUrl: {
      type: String,
      default: '',
      required: true
    },
    thumbnailURL: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    videoClass() {
      // let videoClass = 'video-js vjs-default-skin';
      let videoClass = '';
      if (!(this.videoSourceLoaded && this.browserSupported))
        videoClass += ' blur';
      return videoClass;
    }
  },
  data() {
    return {
      videoSourceLoaded: false,
      browserSupported: true,
      // REF: https://aws.github.io/amazon-ivs-player-docs/1.3.1/web/
      awsIvsVideoJsURL:
        'https://player.live-video.net/1.3.1/amazon-ivs-player.min.js',
      videoCheckStateIntervalID: '',
      player: null
    };
  },
  async mounted() {
    await this.$loadScript(this.awsIvsVideoJsURL);
    this.setUpPlayer();
  },
  methods: {
    setUpPlayer() {
      // eslint-disable-next-line no-undef
      this.player = IVSPlayer.create();

      // attach player to video element
      this.player.attachHTMLVideoElement(
        document.getElementById('amazonIvsVideojs')
      );

      // eslint-disable-next-line no-undef
      if (!IVSPlayer.isPlayerSupported) {
        this.browserSupported = false;
        return;
      }

      // player configuration
      this.player.setAutoplay(true); // auto play

      this.player.addEventListener('PlayerError', () => {
        console.error('player error');
      });

      // load source
      this.loadSource(this.player);
    },
    loadSource(player) {
      this.videoCheckStateIntervalID = setInterval(() => {
        try {
          player.load(this.liveUrl);
          const state = player.getState();
          if (state == 'Playing' || state == 'Buffering' || state == 'Ready') {
            this.videoSourceLoaded = true;
            clearInterval(this.videoCheckStateIntervalID);
          }
        } catch {
          return;
        }
      }, 500);
    },
    switchSpeaker(value) {
      document.getElementById('amazonIvsVideojs').muted = !value;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.delete();
    }
    clearInterval(this.videoCheckStateIntervalID);
  }
};
</script>

<style lang="scss" scoped>
#video {
  margin: auto;
  @include touch {
    height: calc(100vw*2/3);
  }
  /* height: 100%; */

  width: 100%;
  #amazonIvsVideojs {
    width: 100%;
    /* height: 100%; */
    background: black;
    @include touch {
      height: calc(100vw*2/3);
    }
  }
  .blur {
    filter: blur(5px) sepia(1);
  }
  #no-source {
    margin: auto;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 3;
    color: $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    > p {
      text-align: center;
      font-size: medium;
      font-weight: bold;
    }
  }
  #not-suporrted {
    margin: auto;
    /* height: 100%; */
    width: 100%;
    position: absolute;
    z-index: 3;
    color: $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    > p {
      text-align: center;
      font-size: x-large;
      font-weight: bold;
    }
  }
}
</style>
